module.exports = __webpack_public_path__ + "img/6d74205.jpg";